import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './Dropdown.module.scss';
import IconChevronDown from '../Icons/IconChevronDown';

export interface OwnProps {
  value: string;
  children: React.ReactNode;
  expandable?: boolean;
  classNames?: {
    currentValue?: string;
    dropdown?: string;
    options?: string;
  };
}

const Dropdown = ({ children, value, classNames, expandable = true }: OwnProps) => {
  const [isExpanded, expandDropdown] = useState(false);

  const toggleDropdown = () => {
    if (!expandable) return;
    expandDropdown(!isExpanded);
  };

  const collapseDropdown = () => {
    expandDropdown(false);
  };
  useEffect(() => {
    if (isExpanded) {
      window.addEventListener('click', collapseDropdown, false);
    }
    return () => {
      if (!isExpanded) return;
      window.removeEventListener('click', collapseDropdown, false);
    };
  }, [isExpanded]);

  return (
    <div className={cn(styles.dropdown, classNames?.dropdown)}>
      <div className={styles.dropdownWrapper}>
        <div className={cn(styles.currentValue, classNames?.currentValue)} onClick={() => toggleDropdown()}>
          <span>{value}</span>
          <IconChevronDown />
        </div>
        <div
          className={cn(styles.options, classNames?.options, {
            [styles.expanded]: isExpanded,
          })}
          onClick={() => collapseDropdown()}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
